import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Badge from "./Badge/Badge";
import * as leaveApprovalActions from "../domain/leaveApproval/leaveApprovalActions";
import { getUserInfo } from "../../api/axios";
import "./ApprovalBadge.css";

class ApprovalBadge extends Component {
    componentDidMount() {
        this.loadPendingApprovals();
    }

    componentDidUpdate(prevProps) {
        // Refresh pending approvals when user changes
        const currentUser = getUserInfo();
        const prevUser = prevProps.currentUser;

        if (currentUser?.id !== prevUser?.id) {
            this.loadPendingApprovals();
        }
    }

    loadPendingApprovals = () => {
        const userInfo = getUserInfo();
        if (userInfo && userInfo.id) {
            this.props.leaveApprovalActions.getPendingApprovalsForUser(userInfo.id);
        }
    };

    render() {
        const { leaveApprovalReducer } = this.props;
        const { pendingCount } = leaveApprovalReducer;

        if (pendingCount === 0) {
            return null;
        }

        return (
            <Badge
                color="red"
                size="mini"
                className="approval-badge"
                content={pendingCount > 99 ? "99+" : pendingCount}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    leaveApprovalReducer: state.leaveApprovalReducer,
    currentUser: state.accountReducer?.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
    leaveApprovalActions: bindActionCreators(leaveApprovalActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalBadge);
